import Allowance from "./Allowance";

export default Allowance;
